module.exports = __webpack_public_path__ + "img/free.18320e31.jpg";